import { render, staticRenderFns } from "./MainNavigation.vue?vue&type=template&id=05d548a8&scoped=true&tag=nav&class=app-navigation%20app-navigation__nav&"
import script from "./MainNavigation.vue?vue&type=script&lang=js&"
export * from "./MainNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MainNavigation.vue?vue&type=style&index=0&id=05d548a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d548a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemTitle,VMenu})
